import React from "react";
import { Link } from "react-router-dom";
import "./ProjectsGrid.css";

// Project image imports based on website project references
import riverstoneResidence from "../image/featured-project-gallery/project-gallery-04.png"; // Goa Villa Residence
import displayImage from "../image/featured-project-gallery/project-gallery-03.jpeg"; // Residential Project
import shindeHouse from "../image/projects-grid-images/shinde-house-image/shinde house c bed.png"; // Nigadi House
import pranavKhot from "../image/interior-projects/orchid-tv-unit-01.jpeg";
import aurangabadHouse from "../image/projects-grid-images/bunglow-image/warm-living-tv-unit1.png"; // Warm Wood Residence
import commercialProject from "../image/architecture-projects/ved-estate-01.png";

const PROJECTS = [
  {
    slug: "shinde-house",
    image: shindeHouse,
    alt: "Shinde House, 3BHK Bunglow in Nigadi Pradhikaran, Pune",
    tag: "Actual site picture",
    title: "Shinde House ",
    status: "Completed",
    details: [
      { label: "Location", value: "Nigadi Pradhikaran, Pune" },
      { label: "Type", value: "3BHK Bunglow" },
      { label: "Area", value: "2200 sq ft" },
      {
        label: "Scope",
        value: "Complete renovation, including toilet, electrical work, flooring, and furniture.",
      },
    ],
  },

  {
    slug: "stellar-homes",
    image: displayImage,
    alt: "The Stellar Homes, 2BHK Apartment in Wakad, Pune",
    tag: "Actual site picture",
    title: "Residential Project",
    status: "Completed",
    offset: true,
    details: [
      { label: "Location", value: "Wakad, Pune" },
      { label: "Type", value: "2BHK Apartment" },
      { label: "Area", value: "750 sq ft" },
      {
        label: "Scope",
        value: "Full interior · kitchen, wardrobes, living, lighting",
      },
    ],
  },

  {
    slug: "bunglow-interior",
    image: aurangabadHouse,
    alt: "Bunglow Interior, 4BHK Bunglow in Vaijapur",
    tag: "Actual site picture",
    title: "Bunglow Architecture and Interior",
    status: "Completed",
    details: [
      { label: "Location", value: "Vaijapur" },
      { label: "Type", value: "4BHK Bunglow " },
      { label: "Area", value: "2500 sq ft" },
      {
        label: "Scope",
        value: "Full interior · kitchen, wardrobes, living, lighting",
      },
    ],
  },

  {
    slug: "goa-villa",
    image: riverstoneResidence,
    alt: "Riverstone Residence, 4BHK Apartment in Baner, Pune",
    tag: "Upcoming",
    title: "Goa Villa Residence",
    status: "In the Making",
    offset: true,
    details: [
      { label: "Location", value: "Goa, MH" },
      { label: "Type", value: "4BHK Villa" },
      { label: "Area", value: "1,850 sq ft" },
      {label: "Scope", value: "Villa planning · architecture · landscape · interior",},
    ],
  },
];




function ProjectCard({ project }) {

  // const projectUrl =
  //   project.slug === "shinde-house"
  //     ? "/projects/shinde-house"
  //     : project.slug === "bunglow-interior"
  //     ? "/projects/bunglow-interior"
  //     : "/projects";

  const projectUrl =
  project.slug === "shinde-house"
    ? "/projects/shinde-house"
    : project.slug === "bunglow-interior"
    ? "/projects/bunglow-interior"
    : project.slug === "goa-villa"
    ? "/projects/goa-villa"
    : "/projects/residential-homes";

  return (
    <article
      className={`pg-article${project.offset ? " pg-article--offset" : ""}`}
    >
      <Link
        to={projectUrl}
        className="pg-reveal-img"
        aria-label={`View details for ${project.title}`}
      >
        <img
          src={project.image}
          alt={project.alt}
          width={1200}
          height={1504}
          loading="lazy"
          className="pg-image"
        />

        <span className="pg-badge">{project.tag}</span>
      </Link>

      <Link
        to={projectUrl}
        className="pg-header-row"
        aria-label={`View details for ${project.title}`}
      >
        <span className="pg-status">{project.status}</span>

        <div className="pg-title-row">
          <h2 className="pg-title">{project.title}</h2>

          <span className="pg-arrow" aria-hidden="true">
            ↗︎
          </span>
        </div>
      </Link>

      <dl className="pg-details">
        {project.details.map((d) => (
          <div className="pg-detail" key={d.label}>
            <dt className="pg-detail-label">{d.label}</dt>
            <dd className="pg-detail-value">{d.value}</dd>
          </div>
        ))}
      </dl>
    </article>
  );
}

export default function ProjectsGrid() {
  return (
    <section className="pg-section" id="projects">
      <div className="pg-section-header">
        <h1 className="pg-section-title">Selected work</h1>
        <Link to="/projects" className="pg-all-link">
          All Projects <span aria-hidden="true">→</span>
        </Link>
      </div>

      <div className="pg-grid">
        {PROJECTS.map((project) => (
          <ProjectCard project={project} key={project.title} />
        ))}
      </div>

      <div className="pg-cta-wrap">
        <Link to="/projects" className="pg-cta-btn">
          View All Projects
        </Link>
      </div>
    </section>
  );
}
